/* eslint-disable prettier/prettier */
/* prettier-ignore */
import { TranslationMap } from './default'

export const th: TranslationMap = {
  "accountstatus.Active": "บัญชีเคลื่อนไหวปกติ",
  "accountstatus.Inactive": "บัญชีถูกยกเลิก ",
  "accountstatus.Terminated": "บัญชีสิ้นสุด",
  "additionalitems.title": "รายการเพิ่มเติม",
  "cart.addtocart": "หยิบใส่ตะกร้า",
  "cart.addtocart.alreadyincart": "@@PRODUCT@@ อยู่ในตะกร้าของคุณแล้ว",
  "cart.addtocart.currencylocked": "ขณะนี้ตะกร้าสินค้าของคุณตั้งค่าเป็น @@CURRENCY@@ ไม่สามารถรวมหลายสกุลเงินในคำสั่งเดียวได้ หากต้องการซื้อผลิตภัณฑ์นี้โปรดล้าง @@SHOPPING_CART@@ ก่อน",
  "cart.addtocart.locked": "สกุลเงินในตะกร้าของคุณได้รับการตั้งค่าเป็น @@CURRENCY@@ โดยมีสถานที่จัดส่งต่อไปนี้ @@LOCATION@@",
  "cart.addtocart.shiptolocked": "ตระกร้าสินค้าของคุณได้รับการตั้งค่า ตามสถานที่จัดส่งที่ระบุเรียบร้อยแล้ว \n\n@@LOCATION@@\n\nหากต้องการซื้อผลิตภัณฑ์นี้ โปรดเปลี่ยนสถานที่จัดส่งใน @@SHOPPING_CART@@  ก่อน",
  "cart.addtocart.success": "@@PRODUCT@@ ถูกเพิ่มในตะกร้าของคุณแล้ว",
  "cart.empty": "รถเข็นของคุณว่างเปล่า",
  "cart.empty.title": "ตะกร้าสินค้าของคุณว่างเปล่า",
  "cart.gotoproductlist": "ไปที่รายการผลิตภัณฑ์",
  "cart.nolongervalid": "รถเข็นของคุณข้อมูลไม่ถูกต้องโปรดทำรายการให้ถูกต้อง เพื่อดำเนินการต่อ",
  "cart.recalculate": "คำนวณใหม่",
  "cart.recalculate.rounding": "จำนวนที่ขอถูกปัดขึ้นเพื่อให้พอดีกับขนาดบรรจุภัณฑ์",
  "cart.removefromcart.success": "@@PRODUCT@@ ถูกลบออกจากรถเข็นของคุณสำเร็จแล้ว",
  "cart.removeproduct": "คุณแน่ใจหรือไม่ว่าต้องการลบ @@PRODUCT@@ ออกจากตะกร้าสินค้าของคุณ?",
  "cart.requestquote": "ขอใบเสนอราคา",
  "cart.updatecart": "ยืนยันการแก้ไข",
  "cart.updatecart.success": "@@PRODUCT@@ ได้รับการอัปเดตในรถเข็นของคุณแล้ว",
  "dangerousgoodsclass.1": "ระเบิด (1)",
  "dangerousgoodsclass.2.1": "ก๊าซไวไฟ (2.1)",
  "dangerousgoodsclass.2.2": "ก๊าซไม่ติดไฟ (2.2)",
  "dangerousgoodsclass.2.3": "ก๊าซพิษ (2.3)",
  "dangerousgoodsclass.3": "ของเหลวไวไฟ (3)",
  "dangerousgoodsclass.4.1": "ของแข็งไวไฟ (4.1)",
  "dangerousgoodsclass.4.2": "ของแข็งไวไฟติดไฟได้ (4.2)",
  "dangerousgoodsclass.4.3": "อันตรายเมื่อเปียก (4.3)",
  "dangerousgoodsclass.5.1": "ออกซิไดซ์ (5.1)",
  "dangerousgoodsclass.6.1": "เป็นพิษ (6.1)",
  "dangerousgoodsclass.6.2": "ไบโอฮาซาร์ด (6.2)",
  "dangerousgoodsclass.7": "กัมมันตภาพรังสี (7)",
  "dangerousgoodsclass.8": "กัดกร่อน (8)",
  "dangerousgoodsclass.9": "เบ็ดเตล็ด (9)",
  "date.invalid": "วันที่ที่เลือกไม่ถูกต้อง",
  "datefilteroption.last3Months": "3 เดือนล่าสุด",
  "datefilteroption.lastMonth": "เดือนที่แล้ว",
  "datefilteroption.lastWeek": "อาทิตย์ที่แล้ว",
  "datefilteroption.lastYear": "ปีที่แล้ว",
  "field.duplicatedphonenumber": "มีหมายเลขโทรศัพท์ในระบบแล้ว",
  "field.invalid": "@@VALUE@@ ไม่ถูกต้อง",
  "field.invalidinternalemail": "อีเมลล์ไม่ถูกต้อง ต้องเป็นอีเมลล์สำหรับ brenntag.com, brenntag-asia.com หรือ digib.com ส่งให้",
  "field.invalidphonenumber": "หมายเลขโทรศัพท์ไม่ถูกต้อง ให้ใช้รูปแบบ +662 1234567",
  "field.required": "ต้องระบุ @@VALUE@@",
  "filter.accessStatus": "สถานะการเข้าถึง",
  "filter.all": "ทั้งหมด",
  "filter.allorders": "คำสั่งซื้อทั้งหมด",
  "filter.allproducts": "ผลิตภัณฑ์ทั้งหมด",
  "filter.apply": "ใช้",
  "filter.brenntagOrderNumber": "หมายเลขคำสั่งซื้อของ Brenntag",
  "filter.compliancerequired": "การปฏิบัติตามข้อกำหนด",
  "filter.createddate": "วันที่สร้าง",
  "filter.customerName": "ชื่อลูกค้า",
  "filter.customerNumber": "หมายเลขลูกค้า",
  "filter.customerpo.placeholder": "กรองตามหมายเลข PO ของลูกค้า",
  "filter.customerponumber": "หมายเลข PO ของลูกค้า",
  "filter.dangerousgoods": "สินค้าอันตราย",
  "filter.deliveryNumber": "หมายเลขใบส่งสินค้า",
  "filter.deliverydate": "วันที่ร้องขอจัดให้ส่ง ",
  "filter.enddate": "วันที่สิ้นสุด",
  "filter.filterby": "กรองตาม",
  "filter.filters": "ตัวกรอง",
  "filter.from": "จาก",
  "filter.hazardous": "สินค้าอันตราย",
  "filter.invoicenumber": "หมายเลขใบแจ้งหนี้",
  "filter.lastlogindate": "วันที่เข้าสู่ระบบล่าสุด",
  "filter.myorders": "คำสั่งซื้อของฉัน",
  "filter.myproducts": "ผลิตภัณฑ์ของฉัน",
  "filter.noresults": "ไม่พบผลลัพธ์",
  "filter.orderdate": "วันที่สั่งซื้อ",
  "filter.otherfilters": "ตัวกรองอื่น ๆ",
  "filter.pill.accessStatus": "สถานะการเข้าถึง",
  "filter.pill.brenntagOrderNumber": "Brenntag คำสั่งซื้อ #",
  "filter.pill.createdDate": "วันที่สร้าง",
  "filter.pill.customerPONumber": "PO #",
  "filter.pill.dangerousGoods": "สินค้าอันตราย",
  "filter.pill.deliveryDate": "วันที่ร้องขอให้จัดส่ง ",
  "filter.pill.dueDate": "วันที่ครบกำหนด",
  "filter.pill.hazardousGoods": "สินค้าอันตราย",
  "filter.pill.invoiceNumber": "หมายเลขใบแจ้งหนี้",
  "filter.pill.issueDate": "วันที่ออกใบแจ้งหนี้",
  "filter.pill.lastLoginDate": "วันที่เข้าสู่ระบบ",
  "filter.pill.orderDate": "วันที่สั่งสินค้า",
  "filter.pill.packageType": "ประเภทบรรจุภัณฑ์",
  "filter.pill.pricePointExists": "ผลิตภัณฑ์พร้อมสั่ง และราคา",
  "filter.pill.productName": "ชื่อผลิตภัณฑ์",
  "filter.pill.productNumber": "หมายเลขผลิตภัณฑ์",
  "filter.pill.quoteDate": "วันที่เสนอราคา",
  "filter.pill.requestedDeliveryDate": "ร้องขอให้จัดส่ง",
  "filter.pill.resetAll": "ตั้งค่าตัวกรองใหม่ทั้งหมด",
  "filter.pill.role": "บทบาท",
  "filter.pill.salesGroupId": "องค์กรขาย",
  "filter.pill.searchQuery": "ค้นหา",
  "filter.pill.shipToLocationId": "ส่งไปที่",
  "filter.pill.status": "สถานะ",
  "filter.pill.updatedDate": "วันที่อัปเดต",
  "filter.pill.userName": "ผู้ใช้",
  "filter.placeholder.customerName": "ค้นหาตามชื่อลูกค้า",
  "filter.placeholder.customerNumber": "ค้นหาตามหมายเลขลูกค้า",
  "filter.placeholder.global": "ค้นหาสินค้า คำสั่งซื้อ หรือแจ้งหนี้...",
  "filter.placeholder.userEmail": "ค้นหาด้วยอีเมล",
  "filter.placeholder.username": "ค้นหาตามชื่อ",
  "filter.pricePointExists": "ผลิตภัณฑ์พร้อมสั่ง และราคา",
  "filter.productName": "ชื่อผลิตภัณฑ์",
  "filter.quoteNumber": "เลขที่ใบเสนอราคา",
  "filter.quotedate": "วันที่เสนอราคา",
  "filter.role": "บทบาท",
  "filter.salesRepName": "ชื่อตัวแทนขาย",
  "filter.salesorganisation": "องค์กรขาย",
  "filter.search-salesorg.placeholder": "ค้นหาตามลูกค้า หรือองค์กรการขาย",
  "filter.search.placeholder": "ค้นหา",
  "filter.shipto": "ส่งไปที่",
  "filter.startdate": "วันที่เริ่ม",
  "filter.status": "สถานะ",
  "filter.until": "ไปยัง",
  "filter.updated": "วันที่อัปเดตล่าสุด",
  "filter.user": "ผู้ใช้",
  "filter.userEmail": "อีเมล์",
  "filter.userName": "ชื่อ",
  "footer.contactus": "ติดต่อเรา",
  "footer.faqs": "คำถามที่พบบ่อย",
  "footer.privacypolicy": "คําชี้แจงการคุ้มครองข้อมูลและความเป็นส่วนตัว",
  "footer.termsofuse": "ข้อตกลงการใช้งาน",
  "home.contact.1": "ติดต่อทีมงาน Brenntag Connect",
  "home.contact.2": "คำถามที่พบบ่อย",
  "home.heading.1": "สวัสดี @@USERNAME@@",
  "home.heading.2": "ยินดีต้อนรับสู่ Brenntag Connect!",
  "home.heading.3": "Brenntag Connect เป็นแพลตฟอร์มออนไลน์ สำหรับการสั่งซื้อสารเคมีที่สะดวกรวดเร็ว ด้วยข้อมูลที่อัพเดตเสมอ",
  "home.heading.4": "การดําเนินการด่วน",
  "home.invoices.list.1": "ดูใบแจ้งหนี้",
  "home.invoices.list.2": "ดาวน์โหลดไฟล์ PDF ใบแจ้งหนี้",
  "home.label.explore": "สํารวจ",
  "home.label.viewinvoices": "ดูใบแจ้งหนี้ทั้งหมด",
  "home.label.vieworders": "ดูคำสั่งซื้อทั้งหมด",
  "home.orders.list.1": "ดูประวัติการสั่งซื้อ และสถานะ",
  "home.orders.list.2": "ดาวน์โหลดใบรับรองการวิเคราะห์",
  "home.products.list.1": "ค้นหาแค็ตตาล็อกเบรนน์แท็ก",
  "home.products.list.2": "ดูและดาวน์โหลดเอกสาร SDS/TDS",
  "home.products.list.3": "ผลิตภัณฑ์ในคำสั่งซื้อ",
  "home.profile.list.1": "ส่งออกข้อมูลใบแจ้งหนี้",
  "home.profile.list.2": "ส่งออกข้อมูลการสั่งซื้อ",
  "home.profile.list.3": "ตั้งค่ารหัสผ่านใหม่",
  "home.recent.invoices.due": "ใบแจ้งหนี้ล่าสุดที่ครบกําหนด",
  "home.recent.invoices.issued": "ใบแจ้งหนี้ที่ออกล่าสุด",
  "home.recent.orders.created": "ใบสั่งซื้อที่สร้างขึ้นล่าสุด",
  "home.recent.orders.updated": "ใบสั่งซื้อที่อัพเดตล่าสุด",
  "invoice.customer": "ลูกค้า",
  "invoice.date": "วันที่ทำรายการ",
  "invoice.dueDate": "วันครบกำหนดใบแจ้งหนี้",
  "invoice.noinvoicesfound": "ยังไม่มีใบแจ้งหนี้ เราจะออกใบแจ้งหนี้หลังจากคำสั่งซื้อสมบูรณ์แล้วเท่านั้น",
  "invoice.number": "หมายเลขใบแจ้งหนี้",
  "invoicestatus.Cancelled": "ยกเลิก",
  "invoicestatus.Open": "เปิด",
  "invoicestatus.Paid": "จ่าย",
  "invoicestatus.PaidOnline": "ชำระเงินออนไลน์",
  "invoicestatus.ProcessingPayment": "กำลังดำเนินการชำระเงิน",
  "isolanguage.en": "English",
  "isolanguage.id": "Bahasa Indonesia",
  "isolanguage.ko": "한국어",
  "isolanguage.th": "ไทย",
  "isolanguage.vi": "Tiếng Việt",
  "isolanguage.zh-CN": "中文（簡體）",
  "isolanguage.zh-TW": "中文（繁體）",
  "label.Landline": "โทรศัพท์บ้าน",
  "label.Mobile": "โทรศัพท์มือถือ",
  "label.additionalinformation": "ข้อมูลเพิ่มเติม",
  "label.addresses": "ที่อยู่",
  "label.alternativesizes": "ขนาดทางเลือก",
  "label.amountdue": "จำนวนที่ยังค้างอยู่ทั้งหมด",
  "label.any": "ใดๆ",
  "label.anyquestions": "มีคำถามเพิ่มเติมหรือไม่?",
  "label.batchamount": "จำนวนแบทช์ทั้งหมด",
  "label.batchnumber": "หมายเลขแบทช์",
  "label.batchsize": "ขนาดแบทช์",
  "label.billingaddress": "ที่อยู่เรียกเก็บเงิน",
  "label.billtoaddress": "ที่อยู่สำหรับออกใบแจ้งหนี้",
  "label.billtoaddresses": "ที่อยู่สำหรับออกใบแจ้งหนี้",
  "label.billtoaddressincorrect": "หากต้องการเปลี่ยนรายละเอียดที่อยู่โปรดติดต่อเราผ่าน Chat",
  "label.billtoaddressrequired": "ต้องระบุที่อยู่สำหรับออกใบแจ้งหนี้",
  "label.brenntagordernumber": "หมายเลขคำสั่งซื้อ Brenntag",
  "label.browseproducts": "เลือกดูผลิตภัณฑ์",
  "label.browseusers": "เรียกดูผู้ใช้",
  "label.button.attach": "แนบ",
  "label.button.changesalesorg": "ใช่ เปลี่ยนองค์กรการขาย",
  "label.button.editprofile": "แก้ไขโปรไฟล์ของฉัน",
  "label.button.export": "ส่งออก",
  "label.button.nokeep": "ไม่เก็บ",
  "label.button.update": "อัพเดต",
  "label.button.yesterminate": "ใช่ ยุติ",
  "label.by": "โดย",
  "label.callus": "โปรดติดต่อเรา",
  "label.cancel": "ยกเลิก",
  "label.category": "ประเภท",
  "label.changepassword": "รีเซ็ตรหัสผ่าน",
  "label.changesalesorg": "เปลี่ยนองค์กรการขาย",
  "label.changesalesorgwarning": "คุณแน่ใจหรือไม่ว่าคุณต้องการเปลี่ยนองค์กรการขาย",
  "label.checkingavailability": "ตรวจสอบความพร้อม…",
  "label.clickheretoreview": "คลิกที่นี่เพื่อตรวจสอบไฟล์",
  "label.comments": "ความคิดเห็น",
  "label.company": "บริษัท",
  "label.confirmeddeliveryamount": "ยืนยันจำนวนการจัดส่ง",
  "label.continueshopping": "ช้อปปิ้งต่อ",
  "label.country": "ประเทศ",
  "label.creationdate": "วันที่สร้าง",
  "label.creditnote": "ใบลดหนี้",
  "label.customer": "ลูกค้า",
  "label.customername": "ชื่อลูกค้า",
  "label.customernumber": "หมายเลขลูกค้า",
  "label.customerponumber": "หมายเลข PO ของลูกค้า",
  "label.customerporeference": "หมายเลขอ้างอิง PO ของลูกค้า",
  "label.customerporeferencemaxlength": "การอ้างอิง PO ของลูกค้าต้องมีความยาวไม่เกิน @@LENGTH@@ อักขระ",
  "label.customerporeferencerequired": "จำเป็นต้องมีการอ้างอิง PO ของลูกค้า",
  "label.dangerousgoodsclass": "สินค้าอันตราย",
  "label.dangerousgoodscode": "DG",
  "label.datedelivered": "วันที่จัดส่ง",
  "label.datefrom": "จากวันที่",
  "label.dateissued": "วันที่ทำรายการ",
  "label.dateto": "ถึงวันที่",
  "label.debitnote": "ใบเพิ่มหนี้",
  "label.defaultlanguage": "ภาษา",
  "label.delete": "ลบ",
  "label.deliverynumber": "หมายเลขใบส่งสินค้า",
  "label.details": "รายละเอียด",
  "label.discountperpack": "ส่วนลดต่อแพ็ค",
  "label.distributionchannel": "ช่องทางการจัดจำหน่าย",
  "label.division": "แผนก",
  "label.documents": "ดาวน์โหลดเอกสาร",
  "label.dontshowthis": "ไม่ต้องแสดงข้อความนี้อีกต่อไป",
  "label.download.all": "ดาวน์โหลดทั้งหมด",
  "label.download.pdf": "ดาวน์โหลด PDF",
  "label.editmode": "โหมดแก้ไข",
  "label.email": "ที่อยู่อีเมล",
  "label.emailaddress": "ที่อยู่อีเมล",
  "label.exportdata": "ส่งออกข้อมูล",
  "label.exporting": "กำลังส่งออกข้อมูลอาจใช้เวลาสักครู่ ...",
  "label.exportingerror": "เกิดข้อผิดพลาดในการส่งออกไฟล์โปรดลองอีกครั้ง",
  "label.exportinglonger": "ยังคงสร้างการส่งออก อาจใช้เวลาสักครู่",
  "label.exportingsuccess": "ส่งออกไฟล์ข้อมูลเรียบร้อยแล้ว",
  "label.exportordersinvoicescsv": "ส่งออกข้อมูลที่มีโครงสร้างของคำสั่งซื้อและใบแจ้งหนี้ของคุณโดยตรงเป็นไฟล์ CSV หรือ Excel (XLSX)",
  "label.exportselectcategory": "เลือกหมวดหมู่และช่วงวันที่สำหรับส่งออกไฟล์",
  "label.externaluserfile": "ไฟล์ผู้ใช้ภายนอก",
  "label.filesattached": "ไฟล์ที่แนบมา",
  "label.from": "จาก:",
  "label.fullname": "ชื่อเต็ม",
  "label.hazardousgoodscode": "HZ",
  "label.hazchem": "HazChem",
  "label.internaluserfile": "ไฟล์ผู้ใช้ภายใน",
  "label.invoice": "ใบแจ้งหนี้",
  "label.invoice.status.Cancelled": "ยกเลิก",
  "label.invoice.status.Open": "เปิด",
  "label.invoice.status.Paid": "จ่าย",
  "label.invoice.status.PaidOnline": "ชำระเงินออนไลน์",
  "label.invoice.status.ProcessingPayment": "กำลังดำเนินการชำระเงิน",
  "label.item": "รายการ",
  "label.items": "รายการ",
  "label.language": "ภาษา",
  "label.lastlogin": "เข้าสู่ระบบครั้งสุดท้าย",
  "label.learn_more_about_brenntag": "เรียนรู้เพิ่มเติมเกี่ยวกับ Brenntag Connect",
  "label.logout": "ออกจากระบบ",
  "label.minimumquantity": "ปริมาณขั้นต่ํา",
  "label.myprofile": "ประวัติของฉัน",
  "label.name": "ชื่อเต็ม",
  "label.next-step": "ขั้นตอนต่อไป",
  "label.no": "ไม่",
  "label.no-filesattached": "ไม่มีไฟล์แนบ",
  "label.no-filesuploaded": "ไม่มีไฟล์ที่อัปโหลด",
  "label.none": "ไม่มี ",
  "label.nopriceavailable": "ไม่มีราคา",
  "label.notes": "หมายเหตุ",
  "label.orderNumber": "เลขที่คำสั่งซื้อ",
  "label.orderamount": "จำนวนสั่งซื้อ",
  "label.orderamount.zero": "จำนวนสั่งซื้อต้องไม่เป็น 0 คุณสามารถนำสินค้าออกจากรถเข็นของคุณ",
  "label.orderdate": "วันที่สั่งซื้อ",
  "label.orderdetails": "รายละเอียดการสั่งซื้อ",
  "label.orderfiles": "ไฟล์คำสั่งซื้อ",
  "label.orderlist": "รายการสั่งซื้อ",
  "label.ordervalue": "มูลค่าการสั่งซื้อ",
  "label.pack": "บรรจุภัณฑ์",
  "label.packaging": "บรรจุภัณฑ์",
  "label.packaginginformation": "ข้อมูลบรรจุภัณฑ์",
  "label.packinggroup": "กลุ่มบรรจุภัณฑ์",
  "label.packsize": "ขนาดบรรจุภัณฑ์",
  "label.packtype": "ประเภทบรรจุภัณฑ์",
  "label.paymentreference": "หลักฐานการจ่ายเงิน",
  "label.paymentterms": "เงื่อนไขการชำระเงิน",
  "label.payonline": "ชำระเงินออนไลน์",
  "label.personalinfo": "ข้อมูลผู้ใช้",
  "label.phonenumber": "หมายเลขโทรศัพท์",
  "label.placeorder": "สั่งซื้อ",
  "label.placingorder": "การสั่งซื้อ",
  "label.preferences": "ค่ากำหนด",
  "label.previous-step": "ขั้นตอนก่อนหน้า",
  "label.price": "ราคา",
  "label.priceperpack": "ราคา ต่อ แพ็ค",
  "label.pricesareexclusiveofsurcharges": "ราคานี้ไม่รวมภาษีมูลค่าเพิ่ม และค่าธรรมเนียมอื่นๆ",
  "label.pricesaresubjecttochange": "ราคาอาจมีการเปลี่ยนแปลง.",
  "label.productname": "ชื่อผลิตภัณฑ์",
  "label.productnumber": "หมายเลขผลิตภัณฑ์",
  "label.products": "ผลิตภัณฑ์",
  "label.producttype": "ประเภทผลิตภัณฑ์",
  "label.profile": "ข้อมูลส่วนตัว",
  "label.purchaseOrderNumber": "หมายเลข PO ของลูกค้า",
  "label.quantity": "ปริมาณ",
  "label.quantity.minimumorderamount": "จำนวนเงินต้องมากกว่าหรือเท่ากับ @@MINIMUMORDERAMOUNT@@",
  "label.quantity.minimumorderquantity": "จำนวนต้องมากกว่าหรือเท่ากับ @@MINIMUMORDERQUANTITY@@",
  "label.quantity.tiereddiscounts": "มีส่วนลดตามปริมาณ",
  "label.quantity.toolarge": "มูลค่ามากเกินไป",
  "label.quantity.zero": "ค่าต้องมากกว่า 0",
  "label.quotedate": "วันที่เสนอราคา",
  "label.quotenumber": "เลขที่ใบเสนอราคา",
  "label.records": "รายการ",
  "label.redirecttoadmin": "ไปที่อินเทอร์เฟซการดูแลระบบ",
  "label.remove": "เอาออก",
  "label.removeproduct": "นำผลิตภัณฑ์ออก",
  "label.reorder": "สั่งซื้อใหม่อีกครั้ง",
  "label.reorderall": "สั่งซื้อใหม่ทั้งหมด",
  "label.requestcancellation": "ขอยกเลิก",
  "label.requestedamount": "จำนวนที่ร้องขอ",
  "label.requesteddeliverydate": "วันที่ร้องขอให้จัดส่ง ",
  "label.requesteddeliverydate.tooltip": "โปรดทราบว่าเราไม่สามารถรับประกันวันจัดส่งที่คุณร้องขอได้เสมอไป การจัดส่งขึ้นอยู่กับความพร้อมและการยืนยันจากทีม Brenntag ของเรา",
  "label.requesteddeliverydate.warning": "ขึ้นอยู่กับความพร้อมให้บริการ และการยืนยันจากทีมเบรนน์แท็ก",
  "label.requesteddeliverydaterequired": "ต้องระบุวันที่ร้องขอให้จัดส่ง",
  "label.requestquote": "ขอใบเสนอราคา",
  "label.retry": "ลองอีกครั้ง",
  "label.role": "บทบาท",
  "label.role.Admin": "ผู้ดูแลระบบ",
  "label.role.CSR": "ลูกค้าสัมพันธ์",
  "label.role.ReadUser": "ผู้อ่าน",
  "label.role.SuperAdmin": "ผู้ดูแลระบบขั้นสูง",
  "label.role.User": "ผู้ใช้",
  "label.role.UserAdmin": "ผู้ดูแลระบบผู้ใช้",
  "label.role.UserManager": "ตัวจัดการผู้ใช้",
  "label.salesorganisation": "องค์กรขาย",
  "label.scheduleddeliverydate": "กำหนดวันส่งมอบ",
  "label.selectpaymentmethod": "เลือกวิธีการชำระเงินของคุณ",
  "label.selectsalesorganisation": "เลือกองค์กรขาย",
  "label.shelflife": "อายุการเก็บรักษา",
  "label.shippinginstructions": "เงื่อนไขในการจัดส่ง",
  "label.shipto": "ส่งไปที่",
  "label.shiptoaddress": "ที่อยู่สำหรับการจัดส่ง",
  "label.shiptoaddresses": "ที่อยู่สำหรับการจัดส่ง",
  "label.shiptoaddressincorrect": "การเลือกที่อยู่ในการจัดส่งมีความสำคัญ เนื่องจากราคาของสินค้าที่ถูกต้อง  จะแสดงตามที่อยู่ส่งของที่ท่านเลือก โปรดติดต่อเราทาง chat หากท่านไม่พบที่อยู่สำหรับส่งของ หรือที่อยู่ไม่ถูกต้อง",
  "label.shiptoaddressrequired": "ต้องระบุที่อยู่สำหรับจัดส่ง",
  "label.shoppingcart": "ตะกร้าสินค้า",
  "label.size": "ขนาด",
  "label.soldtoaddress": "ที่อยู่สำหรับออกใบแจ้งหนี้",
  "label.sortby": "เรียงตาม",
  "label.specifications": "ข้อมูลจำเพาะ",
  "label.statusacknowledged": "รับทราบแล้ว",
  "label.statusclosed": "ปิด",
  "label.statusopen": "เปิด",
  "label.storageconditions": "เงื่อนไขการเก็บรักษา",
  "label.subtotal": "ผลรวมย่อย",
  "label.tab.attachedfiles": "ไฟล์ที่แนบมา",
  "label.tab.attachnew": "แนบใหม่",
  "label.tax": "ภาษี",
  "label.temperatureconditions": "สภาวะอุณหภูมิ",
  "label.termsandconditions": "ข้อตกลงและเงื่อนไข",
  "label.timezone": "เขตเวลา",
  "label.total": "รวม",
  "label.type": "ชนิด",
  "label.unitprice": "ราคาต่อหน่วย",
  "label.unnumber": "หมายเลข UN",
  "label.updated": "วันที่อัปเดตล่าสุด",
  "label.user": "ผู้ใช้",
  "label.validfrom": "ใช้ได้ตั้งแต่",
  "label.validto": "ใช้ได้ถึง",
  "label.viewquote": "ดูใบเสนอราคา",
  "label.viewvideos": "ดูวิธีในวิดีโอ",
  "label.yes": "ใช่",
  "label.yourproductnumber": "หมายเลขผลิตภัณฑ์ของคุณ",
  "languageselection.modal.areyousure": "คุณแน่ใจหรือไม่ว่าคุณต้องการเปลี่ยนภาษาของคุณ",
  "languageselection.modal.confirm": "ใช่ เปลี่ยนภาษา",
  "languageselection.modal.description": "การเปลี่ยนภาษาของคุณจะส่งผลต่ออีเมลทั้งหมดของคุณ และส่วนติดต่อผู้ใช้ทั้งหมดในเบรนน์แท็กคอนเนค",
  "languageselection.modal.title": "เปลี่ยนภาษาที่ต้องการ",
  "location.shipto.notavailable": "ผลิตภัณฑ์นี้ไม่มีจำหน่ายสำหรับสถานที่จัดส่งไปยังสถานที่ที่คุณเลือก เลือกสถานที่อื่น",
  "logout.changeswillbelost": "การเปลี่ยนแปลงในหน้านี้จะหายไปหากคุณออกจากระบบ",
  "logout.confirmlogout": "แน่ใจไหมว่าต้องการดำเนินการต่อ",
  "logout.itemsinyourshoppingcartcanbelost": "สินค้าในรถเข็นของคุณอาจสูญหายหากคุณออกจากระบบ",
  "message.accessrestricted": "ดูเหมือนว่าคุณไม่มีสิทธิ์เข้าถึงเพื่อทำสิ่งที่คุณพยายามทำ หากไม่ถูกต้องโปรดติดต่อผู้ดูแลระบบของคุณ",
  "message.admincsrredirect": "ดูเหมือนว่าคุณได้ยกระดับสิทธิ์การเข้าถึงและอยู่ในตำแหน่งที่ไม่ถูกต้อง!",
  "message.areyousure": "เธอแน่ใจหรือ ",
  "message.changesalesorg": "การเปลี่ยนองค์กรการขายจะมีผลต่อแค็ตตาล็อกผลิตภัณฑ์ รายการสั่งซื้อ ใบเสนอราคา ใบแจ้งหนี้ และสินค้าปัจจุบันทั้งหมดในตะกร้าสินค้าในเบรนน์แท็กคอนเนค คุณจะสามารถเปลี่ยนกลับได้ทุกเมื่อที่คุณต้องการ",
  "message.changeswillbelost": "การเปลี่ยนแปลงในหน้านี้จะหายไป",
  "message.documentnotfound": "มีการระบุข้อผิดพลาดเนื่องจากเอกสารซ้ำหรือเสียหายหรือไม่สามารถโหลดเอกสารใหม่ได้",
  "message.noitemstoshow": "ขออภัยไม่มีรายการที่จะแสดง",
  "message.noprices": "ติดต่อเราทางแชทเพื่อขอราคาผลิตภัณฑ์นี้",
  "message.pagenotfound": "ดูเหมือนว่าหน้านี้จะหายไป",
  "message.productnaforshipto": "สถานที่ส่ง ไม่สามารถขอใบเสนอราคาได้ เลือกอันอื่น",
  "order.cancelmodal.button": "ขอยกเลิกคำสั่งซื้อ",
  "order.cancelmodal.question": "แน่ใจไหมว่าต้องการยกเลิกคำสั่งซื้อต่อไปนี้",
  "order.cancelmodal.questionfollowup": "เมื่อคุณยืนยันคำขอยกเลิกคุณจะไม่สามารถยกเลิกการดำเนินการได้",
  "order.cancelmodal.title": "ขอยกเลิกคำสั่งซื้อ",
  "order.cancelmodal.title.poabbr": "ใบสั่งซื้อ",
  "order.coadocument": "เอกสาร CoA",
  "order.confirmationdocument": "ยืนยันการสั่งซื้อ",
  "order.history.batch": "แบทช์",
  "order.history.batch_amount": "จำนวนแบทช์ทั้งหมด",
  "order.history.bill_to": "ออกใบแจ้งหนี้ไปที่",
  "order.history.comment_from_user": "ความคิดเห็น",
  "order.history.deliveryNumber": "หมายเลขใบส่งสินค้า",
  "order.history.delivery_date": "วันที่จัดส่ง",
  "order.history.delivery_information": "ข้อมูลการจัดส่ง",
  "order.history.hide": "ซ่อน",
  "order.history.missing_productname": "ชื่อผลิตภัณฑ์ไม่พร้อมใช้งาน",
  "order.history.nologs": "ไม่มีบันทึกสำหรับคำสั่งซื้อนี้",
  "order.history.number": "จำนวน",
  "order.history.orderDetails": "รายละเอียดการสั่งซื้อ",
  "order.history.orderStatus": "สถานะการสั่งซื้อ",
  "order.history.order_amount": "จำนวนสั่งซื้อ",
  "order.history.payment_terms": "เงื่อนไขการชำระเงิน",
  "order.history.pricing_unit_value": "ราคาต่อหน่วย",
  "order.history.quantity_calculated": "คำนวณปริมาณ",
  "order.history.requested_delivery_date": "วันที่ร้องขอจัดให้ส่ง ",
  "order.history.ship_to": "ส่งไปที่",
  "order.history.shipping_instructions": "คำแนะนำในการจัดส่ง",
  "order.history.show": "แสดง",
  "order.history.sold_to": "ขายให้",
  "order.history.status": "สถานะ",
  "order.history.subtotal_value": "ค่าผลรวมย่อย",
  "order.history.title": "บันทึกประวัติการสั่งซื้อ",
  "order.history.total_value": "มูลค่ารวม",
  "order.invoice.download": "ดาวน์โหลดใบแจ้งหนี้",
  "order.invoice.title": "ใบแจ้งหนี้",
  "order.invoice.titlePlural": "ใบแจ้งหนี้",
  "order.invoice.view": "ดู",
  "order.requestchange.allorderlinesdeleted": "คำสั่งซื้อของคุณต้องมีผลิตภัณฑ์อย่างน้อยหนึ่งรายการ จึงจะใช้ดำเนิการได้หากต้องการยกเลิกคำสั่งซื้อ โปรดเลือก “ขอยกเลิก” หรือติดต่อเราผ่านทางแชท",
  "order.requestchange.close": "ปิด",
  "order.requestchange.closeeditmode": "ปิดโหมดแก้ไข",
  "order.requestchange.closeeditmodeconfirmation": "ใช่ปิดโหมดแก้ไข",
  "order.requestchange.closewarning": "แน่ใจไหมว่าต้องการปิดคำขอเปลี่ยนแปลง",
  "order.requestchange.discardedwarning": "การเปลี่ยนแปลงที่ไม่ได้บันทึกทั้งหมดที่ทำกับคำสั่งซื้อนี้จะถูกยกเลิกและจะไม่ได้รับการพิจารณา",
  "order.requestchange.leavewarning": "แน่ใจไหมว่าต้องการออกจากหน้านี้",
  "order.requestchange.placechangerequest": "ส่งคำขอเปลี่ยนแปลง",
  "order.requestchange.productnotavailable": "ไม่มีผลิตภัณฑ์ หรือราคาสำหรับการขอเปลี่ยนแปลงอีกต่อไปโปรดติดต่อเราทางแชท",
  "order.requestchange.requestchange": "ขอเปลี่ยนแปลง",
  "order.requestchange.shiptoaddressnotavailable": "ไม่มีที่อยู่สำหรับจัดส่งสำหรับคำสั่งซื้อนี้โปรดเลือกที่อยู่สำหรับจัดส่งอื่นหรือติดต่อเราทางแชท",
  "order.requestchange.shiptoaddressnotavailablewarning": "ไม่มีที่อยู่สำหรับจัดส่ง",
  "order.status.Acknowledged": "ยอมรับ",
  "order.status.Cancelled": "ยกเลิก",
  "order.status.Closed": "ปิด",
  "order.status.Confirmed": "ได้รับการยืนยัน",
  "order.status.Invoiced": "ออกใบแจ้งหนี้แล้ว",
  "order.status.Open": "เปิด",
  "order.status.OutForDelivery": "ตารางเวลาสำหรับการจัดส่ง",
  "order.status.Submitted": "ส่ง",
  "order.success.message": "ขณะนี้คำสั่งซื้อของคุณอยู่ระหว่่างการตรวจสอบจาก ทีมงาน Brenntag  เมื่อการตรวจสอบเสร็จสมบูรณ์คุณจะได้รับการยืนยันที่เน้นรายละเอียดสำหรับการจัดส่ง หากคุณมีข้อสงสัยหรือต้องการเปลี่ยนแปลงใด ๆ โปรดติดต่อทีม Brenntag ผ่านทางแชท",
  "order.success.title": "ส่งคำสั่งซื้อของคุณแล้ว",
  "page.AccessRestricted": "การเข้าถึงถูก จำกัด",
  "page.CustomerList": "ลูกค้า",
  "page.Home": "หน้าแรก",
  "page.InvoiceList": "ใบแจ้งหนี้",
  "page.NotFound": "ไม่พบหน้าที่ต้องการ (404)",
  "page.OrderList": "คำสั่งซื้อ",
  "page.PaymentInvoice": "ชำระเงินออนไลน์",
  "page.ProductList": "ผลิตภัณฑ์",
  "page.Profile": "ประวัติของฉัน",
  "page.QuoteList": "เสนอราคา",
  "page.SearchResultsFor": "ผลการค้นหาสําหรับ",
  "page.TermsAndConditions": "ข้อตกลงและเงื่อนไข",
  "page.TermsOfUse": "เงื่อนไขการใช้งาน - Brenntag Connect",
  "page.UserList": "ผู้ใช้งาน",
  "paymentInvoice.error": "ไม่สามารถเรียกใบแจ้งหนี้ของคุณได้ โปรดรีเฟรชหน้า และลองอีกครั้ง",
  "paymentInvoice.infoCard.credit": "เครดิต",
  "paymentInvoice.infoCard.creditcardStoreInfo": "Brenntag ไม่ได้จัดเก็บข้อมูลบัตรเครดิตของลูกค้า",
  "paymentInvoice.infoCard.debitNote": "ใบเพิ่มหนี้",
  "paymentInvoice.infoCard.downloadpdf": "ดาวน์โหลด PDF",
  "paymentInvoice.infoCard.invoice": "ใบแจ้งหนี้",
  "paymentInvoice.infoCard.price": "ราคา",
  "paymentInvoice.infoCard.review": "คลิกเพื่อตรวจสอบไฟล์",
  "paymentInvoice.infoCard.terms": "ข้อกำหนดและเงื่อนไข",
  "paymentRedirect.error.heading": "มีบางอย่างผิดพลาด",
  "paymentRedirect.error.subtitle": "โปรดลองอีกครั้งหรือติดต่อเราทางแชท",
  "paymentRedirect.error.title": "เกิดข้อผิดพลาดระหว่างการชำระเงิน ทำให้ใบแจ้งหนี้ / ใบเพิ่มหนี้ ไม่ได้รับการชำระเงิน",
  "paymentRedirect.invoiceList": "รายการใบแจ้งหนี้",
  "paymentRedirect.invoiceNumber": "หมายเลขใบแจ้งหนี้",
  "paymentRedirect.paidAmount": "จำนวนเงินที่ชำระ",
  "paymentRedirect.paymentReference": "หลักฐานการจ่ายเงิน",
  "paymentRedirect.pending.heading": "อยู่ระหว่างรอการยืนยัน",
  "paymentRedirect.pending.subtitle": "เมื่อการชำระเงินได้รับการยืนยันแล้ว ทีมงาน Brenntag จะดำเนินการ และสถานะจะอัปเดตตามลำดับ",
  "paymentRedirect.pending.title": "การชำระเงินของคุณกำลังรอการยืนยันจากผู้ให้บริการชำระเงิน",
  "paymentRedirect.refused.heading": "การชำระเงินถูกปฏิเสธ",
  "paymentRedirect.refused.subtitle": "โปรดลองอีกครั้งโดยใช้วิธีการชำระเงินอื่น",
  "paymentRedirect.refused.title": "การชำระเงินของคุณถูกปฏิเสธจึงไม่สำเร็จ",
  "paymentRedirect.success.heading": "ขอขอบคุณ",
  "paymentRedirect.success.subtitle": "ใบแจ้งหนี้ของคุณได้ชำระแล้ว ทีม Brenntag จะดำเนินต่อกับการชำระเงิน และอัปเดตสถานะใบแจ้งหนี้",
  "paymentRedirect.success.title": "คุณชำระเงินเรียบร้อยแล้วและคำขอของคุณกำลังดำเนินการ",
  "paymentterms.A001": "120 DAYS FROM INV DD, BY 15TH",
  "paymentterms.A002": "15 DAYS FROM INV DD, BY 25T",
  "paymentterms.A003": "15 DAYS FROM INV DD, BY 5TH",
  "paymentterms.A004": "30 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A005": "30 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A006": "30 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A007": "30 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A008": "45 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A009": "45 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A010": "60 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A011": "60 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A012": "60 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A013": "60 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A014": "75 DAYS FROM INV DATE, BY EOM",
  "paymentterms.A015": "90 DAYS FROM INV DATE, BY 10TH",
  "paymentterms.A016": "90 DAYS FROM INV DATE, BY 15TH",
  "paymentterms.A017": "90 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.A018": "90 DAYS FROM INV DATE, BY 25TH",
  "paymentterms.A019": "60 DAYS FROM INV DATE, BY 26TH",
  "paymentterms.A020": "45 DAYS FROM INV DATE BY 10TH",
  "paymentterms.A021": "0-10:20,11-20:EoM,>=21 NxtM10",
  "paymentterms.A022": "INV 26-10:PAY 14,11-25: PAY 28",
  "paymentterms.A023": "CUT OFF 20TH, PAY ON 28TH",
  "paymentterms.A024": "45D FR INV;PAY 2ND/12TH/22ND",
  "paymentterms.A025": "45D (CUT-OFF 25TH) BY 15TH",
  "paymentterms.A026": "150D FROM INV DATE, PAY 25TH",
  "paymentterms.B004": "4 DAYS FROM INV DATE",
  "paymentterms.B005": "5 DAYS FROM INV DATE",
  "paymentterms.B007": "7 DAYS FROM INV DATE",
  "paymentterms.B009": "9 DAYS FROM INV DATE",
  "paymentterms.B010": "10 DAYS FROM INV DATE",
  "paymentterms.B013": "13 DAYS FROM INV DATE",
  "paymentterms.B014": "14 DAYS FROM INV DATE",
  "paymentterms.B015": "15 DAYS FROM INV DATE",
  "paymentterms.B018": "18 DAYS FROM INV DATE",
  "paymentterms.B020": "20 DAYS FROM INV. DATE",
  "paymentterms.B021": "21 DAYS FROM INV DATE",
  "paymentterms.B022": "22 DAYS FROM INV DATE",
  "paymentterms.B028": "28 DAYS FROM INV DATE",
  "paymentterms.B029": "29 DAYS FROM INV DATE",
  "paymentterms.B030": "30 DAYS FROM INV DATE",
  "paymentterms.B037": "37 DAYS FROM INV DATE",
  "paymentterms.B038": "38 DAYS FROM INV DATE",
  "paymentterms.B040": "40 DAYS FROM INV DATE",
  "paymentterms.B045": "45 DAYS FROM INV DATE",
  "paymentterms.B050": "50 DAYS FROM INV DATE",
  "paymentterms.B055": "55 DAYS FROM INV DATE",
  "paymentterms.B060": "60 DAYS FROM INV DATE",
  "paymentterms.B065": "65 DAYS FROM INV DATE",
  "paymentterms.B068": "68 DAYS FROM INV DATE",
  "paymentterms.B070": "70 DAYS FROM INV DATE",
  "paymentterms.B075": "75 DAYS FROM INV DATE",
  "paymentterms.B080": "80 DAYS FROM INV DATE",
  "paymentterms.B085": "85 DAYS FROM INV. DATE",
  "paymentterms.B090": "90 DAYS FROM INV DATE",
  "paymentterms.B105": "105 DAYS FROM INV DATE",
  "paymentterms.B120": "120 DAYS FROM INV DATE",
  "paymentterms.B150": "150 DAYS FROM INV DATE",
  "paymentterms.B180": "180 DAYS FROM INV DATE",
  "paymentterms.B360": "360 DAYS FROM INV DATE",
  "paymentterms.BA01": "50% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA02": "30% ADV, BALANCE 30 DAYS INV",
  "paymentterms.BA03": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA04": "30%TT ADV AND 70 % TT AT SIGHT",
  "paymentterms.BA05": "30%TT ADV AND 70 % DP AT SIGHT",
  "paymentterms.BA06": "80% TT ADV AND 20% TT AT SIGHT",
  "paymentterms.BA07": "20% TT ADV 80% DP AT SIGHT",
  "paymentterms.BA08": "28% TT ADV 72% 60D FR INV DATE",
  "paymentterms.BA09": "70% TT ADV 30% DP AT SIGHT",
  "paymentterms.BA10": "50% TT ADV 50% DP AT SIGHT",
  "paymentterms.BA11": "20% TT ADV 80% TT AT SIGHT",
  "paymentterms.BA12": "40% Advance, 60% B/L date",
  "paymentterms.BA13": "50% Advance, 50% BL date",
  "paymentterms.BA14": "50% ADV, BALANCE 45 DAYS INV",
  "paymentterms.BA15": "50% ADV BAL 45 DAYS BL DATE",
  "paymentterms.BA16": "50% TT ADV, 50 % LC AT SIGHT",
  "paymentterms.BA17": "50% ADV, 50% At SIGHT B/L COPY",
  "paymentterms.BA18": "70% TT ADV, 30% TT AT SIGHT",
  "paymentterms.BA19": "20% TT ADVANCE 80% COD",
  "paymentterms.BA20": "30% DP,70% after 60 days B/L",
  "paymentterms.BA21": "50% ADV, 50% AT SIGHT INV DATE",
  "paymentterms.BA22": "50% Advance 50% Immediate",
  "paymentterms.BA23": "70% TT AT SIGHT,30% TT 75 DAYS",
  "paymentterms.BA24": "50% TT ADV, 50% TT AT SIGHT",
  "paymentterms.BA25": "30% ADV, 70% BL DATE",
  "paymentterms.BA26": "10% DEP AGST PI, 90% TT@SIGHT",
  "paymentterms.BA27": "10% TT ADV, 90% DP AT SIGHT",
  "paymentterms.BA28": "15% TT ADV, 85% DP AT SIGHT",
  "paymentterms.BA29": "40% ADV, BAL COD",
  "paymentterms.BA30": "30% TT ADV, 70% 30D AFT B/L",
  "paymentterms.BA31": "90% CASH IN ADV, 10% TT 90DAYS",
  "paymentterms.BA32": "50% TT ADV, 50% TT 15D FR B/L",
  "paymentterms.BA33": "50% TT ADV, 50% 30D AFT B/L",
  "paymentterms.BA34": "60% ADV, 40% PDC UPON DEL 30D",
  "paymentterms.BA35": "50% ADV/50% 60DAYS FROM INVDAY",
  "paymentterms.BADV": "ADV PAYMENT",
  "paymentterms.BB05": "5 DAYS FROM BL DATE",
  "paymentterms.BB07": "7 DAYS FROM BL DATE",
  "paymentterms.BB10": "10 DAYS FROM BL DATE",
  "paymentterms.BB14": "14 DAYS FROM BL DATE",
  "paymentterms.BB15": "15 DAYS FROM BL DATE",
  "paymentterms.BB20": "20 DAYS FROM BL DATE",
  "paymentterms.BB21": "21 DAYS FROM BL DATE",
  "paymentterms.BB30": "30 DAYS FROM BL DATE",
  "paymentterms.BB35": "35 DAYS FROM BL DATE",
  "paymentterms.BB38": "38 DAYS FROM BL DATE",
  "paymentterms.BB40": "40 DAYS FROM BL DATE",
  "paymentterms.BB45": "45 DAYS FROM BL DATE",
  "paymentterms.BB46": "LC 45 DAYS FROM BL DATE",
  "paymentterms.BB50": "50 DAYS FROM BL DATE",
  "paymentterms.BB60": "60 DAYS FROM BL DATE",
  "paymentterms.BB65": "65 DAYS FROM BL DATE",
  "paymentterms.BB70": "70 DAYS FROM BL DATE",
  "paymentterms.BB75": "75 DAYS FROM BL DATE",
  "paymentterms.BB85": "85 DAYS FROM BL DATE",
  "paymentterms.BB90": "90 DAYS FROM BL DATE",
  "paymentterms.BB97": "97 DAYS FROM BL DATE",
  "paymentterms.BB98": "98 DAYS FROM BL DATE",
  "paymentterms.BB99": "99 DAYS FROM BL DATE",
  "paymentterms.BCBD": "CASH BEFORE DELIVERY",
  "paymentterms.BCOD": "CASH ON DELIVERY",
  "paymentterms.BD01": "D/A 15 DAYS FROM B/L DATE",
  "paymentterms.BD02": "D/A 30 DAYS FROM B/L DATE",
  "paymentterms.BD03": "D/A 45 DAYS FROM B/L DATE",
  "paymentterms.BD04": "D/A 60 DAYS FROM B/L DATE",
  "paymentterms.BD05": "D/A 75 DAYS FROM B/L DATE",
  "paymentterms.BD06": "D/A 90 DAYS FROM B/L DATE",
  "paymentterms.BD07": "D/A 120 DAYS FROM B/L DATE",
  "paymentterms.BD12": "DOC AGNST ACCEPTANCE 120 DAYS",
  "paymentterms.BD15": "DOC AGNST ACCEPTANCE 15 DAYS",
  "paymentterms.BD30": "DOC AGNST ACCEPTANCE 30 DAYS",
  "paymentterms.BD45": "DOC AGNST ACCEPTANCE 45 DAYS",
  "paymentterms.BD60": "DOC AGNST ACCEPTANCE 60 DAYS",
  "paymentterms.BD75": "DOC AGNST ACCEPTANCE 75 DAYS",
  "paymentterms.BD90": "DOC AGNST ACCEPTANCE 90 DAYS",
  "paymentterms.BDAA": "DOCUMENTS AGNST ACCEPTANCE",
  "paymentterms.BDAP": "DOC AGNST ACCEPTANCE AT SIGHT",
  "paymentterms.BE00": "0 DAYS FROM INV DATE, BY 20TH",
  "paymentterms.BE14": "15 DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE15": "15 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE16": "15 DAYS EOM",
  "paymentterms.BE20": "20DAYS FR INV DD, EOM BY 20TH",
  "paymentterms.BE21": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE22": "20 DAYS FR BL DD, EOM BY 20TH",
  "paymentterms.BE23": "20 DAYS EOM BY 25TH",
  "paymentterms.BE30": "30 DAYS EOM BY 20TH",
  "paymentterms.BE31": "EOM BY 25TH",
  "paymentterms.BE32": "32 days end of month by 2nd",
  "paymentterms.BE33": "60 days end of month by 2nd",
  "paymentterms.BE45": "45 DAYS EOM",
  "paymentterms.BE60": "60 DAYS EOM",
  "paymentterms.BE61": "60 DAYS EOM BY 20TH",
  "paymentterms.BE62": "60 DAYS EOM BY 15TH",
  "paymentterms.BE63": "60 days end of month by 4th",
  "paymentterms.BE90": "90 DAYS EOM",
  "paymentterms.BE91": "90 DAYS EOM BY 5TH",
  "paymentterms.BIMM": "IMMEDIATE",
  "paymentterms.BL15": "LC 15 DAYS AT SIGHT",
  "paymentterms.BL21": "LC 21 DAYS AT SIGHT",
  "paymentterms.BL30": "LC 30 DAYS AT SIGHT",
  "paymentterms.BL45": "LC 45 DAYS AT SIGHT",
  "paymentterms.BL60": "LC 60 DAYS AT SIGHT",
  "paymentterms.BL61": "LC 60 DAYS BL",
  "paymentterms.BL75": "LC 75 DAYS AT SIGHT",
  "paymentterms.BL90": "LC 90 DAYS AT SIGHT",
  "paymentterms.BL91": "LC 90 DAYS BL",
  "paymentterms.BLAS": "LC PAYMENT AT SIGHT",
  "paymentterms.BP12": "DOCUMENTS AGNST PAYTS 120 DAYS",
  "paymentterms.BP30": "DOCUMENTS AGNST PAYTS 30 DAYS",
  "paymentterms.BP60": "DOCUMENTS AGNST PAYTS 60 DAYS",
  "paymentterms.BPAA": "D/P AT SIGHT",
  "paymentterms.BTAS": "TT AT SIGHT",
  "paymentterms.CAD1": "CASH AGAINST DOCUMENT",
  "paymentterms.CBO1": "CBO",
  "paymentterms.CBO2": "30% CBO, 70% CBD",
  "paymentterms.CBO3": "50% CBO, 50% CBD",
  "paymentterms.CBO4": "50% CBO, 50% COD",
  "paymentterms.CBO5": "50% CBO, 50% 30 DAYS FROM INV",
  "paymentterms.CNMT": "CNMT - CONSIGNMENT",
  "paymentterms.D001": "TT AGAINST DOCUMENT",
  "paymentterms.D002": "TT IN ADVANCE",
  "paymentterms.D004": "TT EOM 30D BY 20TH FRM BL DD",
  "paymentterms.D005": "TT 30 DAYS FROM INVOICE DATE",
  "paymentterms.D006": "TT 45 DAYS FROM BL DATE",
  "paymentterms.D007": "TT 45 DAYS FROM INV DATE",
  "paymentterms.D008": "TT 60 DAYS FROM INVOICE DATE",
  "paymentterms.D010": "TT 65 DAYS FROM  B/L Date",
  "paymentterms.D011": "TT 25 DAYS FROM INVOICE DATE",
  "paymentterms.D012": "TT AGAINST BL",
  "paymentterms.D013": "7 DAYS T/T AT SIGHT",
  "paymentterms.D014": "T/T BEFORE DELIVERY",
  "paymentterms.D015": "TT UPON ORDER CONFIRMATION",
  "paymentterms.D016": "TT 2 DAYS FROM INVOICE DATE",
  "paymentterms.D017": "TT 90 DAYS FROM INVOICE DATE",
  "paymentterms.DD01": "DIRECT DEBIT 30 DAYS",
  "paymentterms.DD02": "DIRECT DEBIT 60 DAYS",
  "paymentterms.DD03": "DIRECT DEBIT 90 DAYS",
  "paymentterms.E001": "EOM 30 DAYS BY 10TH",
  "paymentterms.E002": "EOM 30 DAYS BY 15TH",
  "paymentterms.E003": "EOM 30 DAYS BY 20TH",
  "paymentterms.E004": "EOM 30 DAYS BY 25TH",
  "paymentterms.E005": "EOM 60 DAYS BY 10TH",
  "paymentterms.E006": "EOM 60 DAYS BY 15TH",
  "paymentterms.E007": "EOM 60 DAYS BY 20TH",
  "paymentterms.E008": "EOM 60 DAYS BY 25TH",
  "paymentterms.E009": "EOM 90 DAYS BY 10TH",
  "paymentterms.E010": "EOM 90 DAYS BY 15TH",
  "paymentterms.E011": "EOM 90 DAYS BY 20TH",
  "paymentterms.E012": "EOM 90 DAYS BY 25TH",
  "paymentterms.E013": "EOM",
  "paymentterms.E014": "EOM 30 DAYS",
  "paymentterms.E015": "EOM 30 DAYS BY 5th",
  "paymentterms.E016": "EOM 30 DAYS BY 10th",
  "paymentterms.E017": "EOM 30D BY 20th",
  "paymentterms.E018": "EOM 30D BY 25th",
  "paymentterms.E019": "EOM 30 DAYS (CUT-OFF 25th)",
  "paymentterms.E020": "EOM 30D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E021": "EOM 30D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E022": "EOM 45 DAYS (CUT-OFF 25th)",
  "paymentterms.E023": "EOM 60 DAYS",
  "paymentterms.E024": "EOM 60 DAYS BY 5th",
  "paymentterms.E025": "EOM 60 DAYS BY 10th",
  "paymentterms.E026": "EOM 60 DAYS BY 15th",
  "paymentterms.E027": "EOM 60 DAYS (CUT-OFF 25th)",
  "paymentterms.E028": "EOM 60D (CUT-OFF 25th) BY 5TH",
  "paymentterms.E029": "EOM 60D (CUT-OFF 25th) BY 10TH",
  "paymentterms.E030": "EOM 90 DAYS",
  "paymentterms.E031": "EOM 90 DAYS BY 7TH",
  "paymentterms.E032": "EOM 90 DAYS (CUT-OFF 20th)",
  "paymentterms.E033": "EOM 90 DAYS (CUT-OFF 25th)",
  "paymentterms.E034": "EOM BY 5TH",
  "paymentterms.E035": "EOM BY 10TH",
  "paymentterms.E036": "EOM 30D (CUT-OFF 20th) BY 15TH",
  "paymentterms.E037": "EOM 90D (CUT-OFF 25th) by 7th",
  "paymentterms.E038": "EOM 45 DAYS (CUT-OFF 25) BY 5",
  "paymentterms.E039": "EOM 60 DAYS (CUT-OFF 20th)",
  "paymentterms.E040": "EOM 90 DAYS (CUT-OFF 25) BY 8",
  "paymentterms.E041": "EOM 60 DAYS (CUT-OFF 25th) 15",
  "paymentterms.E042": "EOM 90 DAYS (CUT-OFF 25th) 5th",
  "paymentterms.E043": "EOM 90 DAYS (CUT-OFF 25th) 10",
  "paymentterms.E044": "EOM 90 DAYS (CUT-OFF 25th)15",
  "paymentterms.E045": "EOM 90 DAYS (CUT-OFF 25th)20th",
  "paymentterms.E046": "EOM 120 DAYS(CUT-OFF 25th)15th",
  "paymentterms.E047": "EOM 30 DAYS (CUT-OFF 25th)15th",
  "paymentterms.E048": "DUE SAME DAY NEXT MTH",
  "paymentterms.E049": "EOM 30 DAYS (DUE ON 27TH)",
  "paymentterms.E050": "EOM 60 DAYS DUE 25th",
  "paymentterms.E051": "EOM 210D",
  "paymentterms.E052": "EOM 105D",
  "paymentterms.E053": "EOM 60 DAYS (CUT-OFF 20TH) 20",
  "paymentterms.E054": "EOM 30 DAYS (CUT-OFF  20th)",
  "paymentterms.E055": "EOM 30D (CUT_OFF 25TH) BY 16TH",
  "paymentterms.E056": "EOM 85D (CUT-OFF 25TH)",
  "paymentterms.E057": "EOM 90D (DUE 5TH FOLLOWING)",
  "paymentterms.E058": "EOM 120D",
  "paymentterms.E059": "EOM (CUT-OFF 25TH) BY 5TH",
  "paymentterms.E060": "EOM 45 DAYS BY 15TH",
  "paymentterms.E061": "64 DAYS FROM EOM",
  "paymentterms.E062": "EOM BY 10TH",
  "paymentterms.E063": "EOM BY 26TH",
  "paymentterms.E064": "EOM 31 days",
  "paymentterms.E065": "EOM 50 DAYS (CUT-OFF 24th)",
  "paymentterms.E120": "120 DAYS EOM",
  "paymentterms.EA65": "65 DAYS ETA",
  "paymentterms.EM15": "EOM 15 DAYS",
  "paymentterms.EM20": "EOM 20 DAYS",
  "paymentterms.EM30": "30 DAYS EOM",
  "paymentterms.EM45": "EOM 45 DAYS",
  "paymentterms.EM65": "EOM 65 DAYS",
  "paymentterms.EM75": "EOM 75 DAYS",
  "paymentterms.EQ01": "End of Quarter (by 20th)",
  "paymentterms.GR10": "10 DAYS AFTER GOODS RECEIPT",
  "paymentterms.GR30": "30 DAYS AFTER GOODS RECEIPT",
  "paymentterms.IK00": "Within 5 days 3% cash discount",
  "paymentterms.L001": "LC 150 DAYS AT SIGHT",
  "paymentterms.L002": "LC 180 DAYS AT SIGHT",
  "paymentterms.L003": "LC 105 DAYS BL",
  "paymentterms.L004": "LC 120 DAYS BL",
  "paymentterms.L005": "LC 150 DAYS BL",
  "paymentterms.L006": "LC 180 DAYS BL",
  "paymentterms.L007": "LC 15 DAYS BL",
  "paymentterms.L030": "LC 30 DAYS BL",
  "paymentterms.L105": "105 DAYS FROM BL DATE",
  "paymentterms.L120": "120 DAYS FROM BL DATE",
  "paymentterms.L150": "150 DAYS FROM BL DATE",
  "paymentterms.L180": "L 180 DAYS FROM BL DATE",
  "paymentterms.LD01": "LAST DAY NEXT MTH",
  "paymentterms.LD02": "LAST DAY OF MTH AFT NEXT MTH",
  "paymentterms.LD03": "LAST DAY OF THREE MONTH LATER",
  "paymentterms.LVT0": "16 days 2%, 31 days net",
  "paymentterms.M001": "3 MONTH LATER BY 5TH",
  "paymentterms.M002": "3 MONTH LATER BY 5TH",
  "paymentterms.MVT0": "10 days 3%, 16  2%, 31 net",
  "paymentterms.P001": "60 DAYS ETA",
  "paymentterms.P002": "90 DAYS ETA",
  "paymentterms.P003": "15 DAYS FROM ETA HCM PORT",
  "paymentterms.P004": "60 DAYS FROM ETA, PAY ON 26TH",
  "paymentterms.PBD1": "PDC BEFORE DEL 30 DAYS",
  "paymentterms.PBD2": "PDC BEFORE DEL 45 DAYS",
  "paymentterms.PBD3": "PDC BEFORE DEL 60 DAYS",
  "paymentterms.PBD4": "PDC BEFORE DEL 90DAYS FROM INV",
  "paymentterms.PBD5": "PDC BEFORE DEL 15 DAYS",
  "paymentterms.PDC1": "30 DAYS PDC FROM INV DATE",
  "paymentterms.PDC2": "60 DAYS PDC FROM INV DATE",
  "paymentterms.PDC3": "45 DAYS PDC FROM INV DATE",
  "paymentterms.PDC4": "15 DAYS PDC FROM INV DATE",
  "paymentterms.PDC5": "90 DAYS PDC FROM INV DATE",
  "paymentterms.PUD1": "PDC UPON DEL 15 DAYS FROM INV",
  "paymentterms.PUD2": "PDC UPON DEL 30 DAYS FROM INV",
  "paymentterms.PUD3": "PDC UPON DEL 45 DAYS FROM INV",
  "paymentterms.PUD4": "PDC UPON DEL 60 DAYS FROM INV",
  "paymentterms.PUD5": "PDC UPON DEL 90 DAYS FROM INV",
  "paymentterms.TX07": "7 DAYS AFTER STOCK ARRIVAL",
  "paymentterms.TX30": "30 DAYS DECLARATION",
  "paymentterms.TX45": "45 DAYS DECLARATION",
  "paymentterms.TX60": "60 DAYS DECLARATION",
  "paymentterms.TX90": "90 DAYS DECLARATION",
  "paymentterms.WALL": "99% forever",
  "paymentterms.WL01": "12 days net",
  "paymentterms.Z001": "custom payment term (test)",
  "paymentterms.ZB00": "Pay immediately w/o deduction",
  "paymentterms.ZB01": "14 Days 3%, 30/2%, 45 net",
  "paymentterms.ZB02": "8 days 5%, 14/2%, 21 net",
  "paymentterms.ZB03": "20 days 2%, 30 days net",
  "paymentterms.ZB04": "10 days 4%, 20/2%, 30 net",
  "paymentterms.ZB05": "5 days 2%, 10 days net",
  "phone.landline": "โทรศัพท์บ้าน",
  "phone.mobile": "โทรศัพท์มือถือ",
  "product.altsizes.loadmore": "โหลดขนาดอื่นเพิ่มเติม",
  "product.discount.saveamount": "ประหยัด @@AMOUNT@@",
  "product.discount.savingspercentage": "@@PERCENTAGE@@ ออมทรัพย์",
  "product.documentType.msds": "เอกสาร SDS",
  "product.documentType.tds": "เอกสาร TDS",
  "product.documenterror": "ไม่สามารถเรียกเอกสารได้",
  "product.loadingdocuments": "กําลังโหลดเอกสาร",
  "product.nodocuments": "ไม่มีเอกสาร",
  "product.safetyinformation": "ข้อมูลด้านความปลอดภัย",
  "product.type.nonvaluated": "วัสดุที่ไม่ประเมินค่า",
  "product.type.packaging": "บรรจุภัณฑ์",
  "product.type.returnable": "บรรจุภัณฑ์ที่ต้องส่งคืน",
  "product.type.sample": "ตัวอย่าง",
  "product.type.services": "บริการ",
  "product.type.tolling": "Tolling",
  "product.type.tolling-raw-material-nonvaluated": "Tolling วัตถุดิบที่ไม่มีการประเมินมูลค่า",
  "product.type.tradinggoods": "สินค้าสำหรับการซื้อขาย",
  "quote.date": "วันที่เสนอราคา",
  "quote.decline": "ปฏิเสธใบเสนอราคา",
  "quote.details": "รายละเอียดใบเสนอราคา",
  "quote.number": "เลขที่ใบเสนอราคา",
  "quote.requoteproduct": "เสนอราคาผลิตภัณฑ์อีกครั้ง",
  "quote.validfrom": "ใช้ได้ตั้งแต่",
  "quote.validto": "ใช้ได้ถึง",
  "quote.value": "มูลค่าใบเสนอราคา",
  "quotestatus.Declined": "ปฏิเสธ",
  "quotestatus.Expired": "ที่หมดอายุแล้ว",
  "quotestatus.InProgress": "กำลังดำเนินการ",
  "quotestatus.Open": "เปิด",
  "quotestatus.Ordered": "สั่งซื้อ",
  "quotestatus.Submitted": "ส่ง",
  "quotestatus.Upcoming": "กำลังจะเกิดขึ้น",
  "regex.placeordertermsandconditions": "การสั่งซื้อนี้คุณยอมรับ @@TERMS_AND_CONDITIONS@@ ของเรา",
  "regex.reviewtermsandconditions": "คลิกที่นี่เพื่อตรวจสอบ @@TERMS_AND_CONDITIONS@@ ของเรา",
  "requestcancellation.request": "ทีมบริการลูกค้า Brenntag ฉันต้องการขอยกเลิกคำสั่งซื้อพร้อมหมายเลขคำสั่งซื้อ: @@ORDER_NUMBER@@ และหมายเลขลูกค้า: @@CUSTOMER_NUMBER@@ โปรดให้การยืนยันหรือข้อมูลเพิ่มเติมตามความจำเป็น",
  "requestchanges.message.billToAddress": "- ที่อยู่สำหรับการเรียกเก็บเงินก่อนหน้า: @@LOCATION_OLD@@ - ที่อยู่สำหรับการเรียกเก็บเงินใหม่: @@LOCATION_NEW@@",
  "requestchanges.message.cancelproduct": "- ยกเลิกสินค้านี้: สินค้า: @@PRODUCT_NAME@@ รหัสผลิตภัณฑ์: @@PRODUCT_NUMBER@@",
  "requestchanges.message.comments": "- ความคิดเห็น: @@COMMENTS_OLD@@ → @@COMMENTS_NEW@@",
  "requestchanges.message.deliverydate": "- วันที่ส่งคำขอ: @@DATE_OLD@@ → @@DATE_NEW@@",
  "requestchanges.message.heading": "ทีมบริการลูกค้า Brenntag คุณช่วยเปลี่ยนข้อมูลต่อไปนี้สำหรับคำสั่งซื้อของฉันได้ไหม: \n\nหมายเลขลูกค้า @@CUSTOMER_NUMBER@@ หมายเลขคำสั่งซื้อ @@PURCHASE_ORDER_NUMBER@@ \n\n---------",
  "requestchanges.message.orderline": "- เปลี่ยนสินค้านี้: สินค้า: @@PRODUCT_NAME@@\nรหัสสินค้า: @@PRODUCT_NUMBER@@\n- จำนวน: @@QUANTITY_OLD@@ → @@QUANTITY_NEW@@\n- จำนวน: @@AMOUNT_OLD@@ @@AMOUNT_UOM_OLD@@ → @@AMOUNT_NEW@@ @@AMOUNT_UOM_NEW@@",
  "requestchanges.message.shipToAddress": "- ที่อยู่จัดส่งก่อนหน้า: \n@@LOCATION_OLD@@ \n\n- ที่อยู่จัดส่งใหม่: \n@@LOCATION_NEW@@",
  "requestquote.request": "ทีมบริการลูกค้าของ Brenntag โปรดเสนอราคาต่อไปนี้: \n\nหมายเลขลูกค้า @@CUSTOMER_NUMBER@@ \n\nผลิตภัณฑ์: @@PRODUCT_NAME@@ \n\nรหัสผลิตภัณฑ์: @@PRODUCT_NUMBER@@ \n\nปริมาณที่ร้องขอ: @@QUANTITY@@ \n\nจำนวนที่ร้องขอ: @@REQUESTED_AMOUNT@@ \n\nที่อยู่ในการจัดส่ง: \n@@SHIP_TO_ADDRESS@@ \n\nวันที่จัดส่งที่ร้องขอ: @@REQUESTED_DELIVERY_DATE@@",
  "show_more.less": "แสดงน้อยลง",
  "show_more.more": "แสดงมากขึ้น",
  "show_more.results": "แสดงผลลัพธ์เพิ่มเติม",
  "something.wrong": "อ๊ะ! บางอย่างผิดพลาด. กรุณาลองอีกครั้ง",
  "something.wrong.documents": "อ๊ะ! บางอย่างผิดพลาด",
  "sortinglabel.-currency": "สกุลเงิน (Z-A)",
  "sortinglabel.-customerName": "ชื่อลูกค้า (Z-A)",
  "sortinglabel.-dueDate": "วันครบกำหนดใบแจ้งหนี้ล่าสุด",
  "sortinglabel.-grossAmount.amount": "จำนวนเงินสูงสุด",
  "sortinglabel.-invoiceNumber": "หมายเลขใบแจ้งหนี้ (Z-A)",
  "sortinglabel.-issueDate": "วันที่ออกใบแจ้งหนี้ล่าสุด",
  "sortinglabel.-lastLoggedInAt": "เข้าสู่ระบบล่าสุด",
  "sortinglabel.-lastUpdateDate": "อัปเดตใหม่ล่าสุด",
  "sortinglabel.-name": "ชื่อผลิตภัณฑ์ (Z-A)",
  "sortinglabel.-netAmount": "ยอดสุทธิสูงสุด",
  "sortinglabel.-orderCreationDate": "วันที่สั่งซื้อล่าสุด",
  "sortinglabel.-packaging.name": "ประเภทบรรจุภัณฑ์ (Z-A)",
  "sortinglabel.-quoteCreationDate": "วันที่เสนอราคาล่าสุด",
  "sortinglabel.-username": "ชื่อ (Z-A)",
  "sortinglabel.-usertype": "ประเภทผู้ใช้ (ภายนอกก่อน)",
  "sortinglabel.currency": "สกุลเงิน (A-Z)",
  "sortinglabel.customerName": "ชื่อลูกค้า (A-Z)",
  "sortinglabel.dueDate": "วันที่ครบกำหนดใบแจ้งหนี้เก่าสุด",
  "sortinglabel.grossAmount.amount": "จำนวนเงินที่ต้องชำระต่ำสุด",
  "sortinglabel.invoiceNumber": "หมายเลขใบแจ้งหนี้ (A-Z)",
  "sortinglabel.issueDate": "วันที่ออกใบแจ้งหนี้เก่าสุด",
  "sortinglabel.lastLoggedInAt": "การเข้าสู่ระบบครั้งล่าสุด เก่าที่สุด",
  "sortinglabel.lastUpdateDate": "อัปเดต เก่าที่สุด",
  "sortinglabel.name": "ชื่อผลิตภัณฑ์ (A-Z)",
  "sortinglabel.netAmount": "ปริมาณสุทธิต่ำสุด",
  "sortinglabel.orderCreationDate": "วันที่สั่งซื้อ เก่าที่สุด",
  "sortinglabel.packaging.name": "ประเภทบรรจุภัณฑ์ (A-Z)",
  "sortinglabel.quoteCreationDate": "วันที่ใบเสนอราคา เก่าที่สุด",
  "sortinglabel.relevance": "ความเกี่ยวข้อง",
  "sortinglabel.username": "ชื่อ (A-Z)",
  "sortinglabel.usertype": "ประเภทผู้ใช้ (ภายนอกก่อน)",
  "storageconditions.01": "ที่เก็บของทั่วไป - สำหรับสินค้าเกี่ยวกับอาหาร, ยา",
  "storageconditions.02": "ที่เก็บข้อมูลทั่วไป",
  "storageconditions.03": "ที่จัดเก็บสินค้าที่เป็นอันตราย",
  "storageconditions.04": "ห้องเย็นสำหรับเก็บ สินค้าเกี่ยวกับอาหาร,ยา",
  "storageconditions.05": "สภาพแวดล้อมที่ติดไฟได้",
  "storageconditions.06": "ห้องเย็นสำหรับเก็บของ",
  "storageconditions.07": "ห้องแช่แข็งสำหรับเก็บของ",
  "storageconditions.08": "ที่จัดเก็บสารทำความเย็น",
  "storageconditions.09": "ที่จัดเก็บแอมโมเนีย",
  "storageconditions.10": "ที่จัดเก็บที่ไม่เป็นไปตามข้อกำหนด",
  "storageconditions.11": "ที่เก็บของเหลวจำนวนมาก",
  "storageconditions.12": "พื้นที่การผลิต",
  "support.email": "support@brenntagconnect.com",
  "support.email.salesgroup.NL01": "orders.au@brenntag-asia.com",
  "support.email.topic": "คำถาม: {customer PO#}/ {quotation #}/ {customer ID}",
  "support.phonenumber": "+123 3453 043",
  "temperatureconditions.01": "> 25 ถึง 40ºC",
  "temperatureconditions.02": "> 15 ถึง 25ºC พร้อมควบคุมความชื้น",
  "temperatureconditions.03": "> 8 ถึง15ºC พร้อมควบคุมความชื้น",
  "temperatureconditions.04": "> 0 ถึง 8ºC พร้อมควบคุมความชื้น",
  "temperatureconditions.05": "> -20 ถึง 0ºC",
  "temperatureconditions.06": "-20ºCและ ต่ำกว่า",
  "terms.agree": "ใช่ฉันเห็นด้วย",
  "terms.description": "โดยการเข้าถึง หรือใช้งานส่วนใดส่วนหนึ่งของเบรนน์แท็กคอนเนค คุณตกลงที่จะผูกพันตามข้อกําหนดการใช้งานเหล่านี้\n\nหากคุณไม่ยอมรับข้อกําหนดและเงื่อนไขทั้งหมดของข้อตกลงนี้คุณจะไม่สามารถเข้าถึงเบรนน์แท็กคอนเนค หรือใช้บริการใด ๆ",
  "terms.disagree": "ไม่, ออกจากระบบ",
  "timeunit.many.day": "วัน",
  "timeunit.many.month": "เดือน",
  "timeunit.many.week": "สัปดาห์",
  "timeunit.many.year": "ปี",
  "timeunit.one.day": "วัน",
  "timeunit.one.month": "เดือน",
  "timeunit.one.week": "สัปดาห์",
  "timeunit.one.year": "ปี",
  "toast.error.coadocuments": "เกิดข้อผิดพลาดในการเรียกเอกสาร CoA",
  "toast.error.createuser": "เกิดข้อผิดพลาดในการสร้างผู้ใช้",
  "toast.error.customernotfound": "บางอย่างผิดพลาด. กรุณาติดต่อ Brenntag Connect",
  "toast.error.customers": "เกิดข้อผิดพลาดในการดึงลูกค้า",
  "toast.error.invoices": "เกิดข้อผิดพลาดในการเรียกข้อมูลใบแจ้งหนี้",
  "toast.error.languagechange": "การเปลี่ยนภาษาล้มเหลว",
  "toast.error.orderdetails": "เกิดข้อผิดพลาดในการเรียกดูรายละเอียดคำสั่งซื้อ",
  "toast.error.orders": "เกิดข้อผิดพลาดในการเรียกข้อมูลประวัติการสั่งซื้อ",
  "toast.error.placingorder": "เกิดข้อผิดพลาดในการสั่งซื้อ",
  "toast.error.price": "เกิดข้อผิดพลาดในการเรียกราคา",
  "toast.error.productdocuments": "มีบางอย่างผิดปกติในการเรียกเอกสารผลิตภัณฑ์",
  "toast.error.products": "เกิดข้อผิดพลาดในการเรียกข้อมูลผลิตภัณฑ์",
  "toast.error.quote": "เกิดข้อผิดพลาดในการเรียกข้อมูลรายละเอียดใบเสนอราคา",
  "toast.error.quotereject": "เกิดข้อผิดพลาดในการปฏิเสธใบเสนอราคา",
  "toast.error.quotes": "เกิดข้อผิดพลาดในการเรียกข้อมูลใบเสนอราคา",
  "toast.error.saveuser": "เกิดข้อผิดพลาดขณะบันทึกการเปลี่ยนแปลงของผู้ใช้",
  "toast.error.userinfo": "เกิดข้อผิดพลาดในการเรียกข้อมูลผู้ใช้",
  "toast.error.userservice": "เกิดข้อผิดพลาดในการเรียกข้อมูลผู้ใช้",
  "toast.error.userservice.emailaddressexists": "ผู้ใช้ที่มีที่อยู่อีเมล @@EMAIL@@ มีอยู่แล้ว",
  "toast.error.userservice.permissionsoutsidesalesgroup": "คุณไม่สามารถสร้าง หรือปรับเปลี่ยนผู้ใช้ที่อยู่นอกกลุ่มการขายที่กําหนดให้กับคุณ",
  "toast.error.userservice.savefailed": "เกิดข้อผิดพลาดขณะบันทึกข้อมูลผู้ใช้",
  "toast.error.validatingcart": "เกิดข้อผิดพลาดขณะตรวจสอบรถเข็น",
  "toast.success.createuser": "สร้างผู้ใช้ @@USER@@ เรียบร้อยแล้ว",
  "toast.success.deleteuser": "ลบผู้ใช้ @@USER@@ เรียบร้อยแล้ว",
  "toast.success.resetpassword": "เราเพิ่งส่งอีเมลถึงคุณ@@EMAIL@@รีเซ็ตรหัสผ่านของคุณ",
  "toast.success.saveuser": "บันทึกผู้ใช้ @@USER@@ เรียบร้อยแล้ว",
  "user.accessrights": "สิทธิ์การเข้าถึงและภาษา",
  "user.accessrights.message": "กำหนดสิทธิ์การเข้าถึงให้กับลูกค้า",
  "user.bcaccessstatus": "สถานะการเข้าถึง Brenntag Connect",
  "user.create": "สร้างผู้ใช้",
  "user.createdon": "สร้างบน",
  "user.delete.confirmation": "การดำเนินการนี้ไม่สามารถยกเลิกได้ ดำเนินการต่อหรือไม่",
  "user.delete.message": "ผู้ใช้ @@USER@@ จะถูกลบออกจากระบบอย่างไม่สามารถย้อนกลับได้",
  "user.edit": "แก้ไขผู้ใช้",
  "user.information": "ข้อมูลผู้ใช้",
  "user.lastpasswordreset": "รีเซ็ตรหัสผ่านล่าสุด",
  "user.modal.terminate.confirmation": "คุณแน่ใจหรือไม่ว่าต้องการยุติผู้ใช้รายนี้",
  "user.modal.terminate.message": "คําเตือน: ผู้ใช้ที่ถูกยกเลิกจะไม่สามารถเข้าสู่ระบบ Brenntag Connect ได้อีกต่อไป",
  "user.notes": "หมายเหตุ",
  "user.notes.placeholder": "ตัวอย่าง: ข้อมูลเกี่ยวกับเวลาทำงาน ผู้ติดต่อสำรอง",
  "user.role": "บทบาท",
  "user.save": "บันทึกการเปลี่ยนแปลง",
  "user.search.customer": "ค้นหาหมายเลข หรือชื่อลูกค้า",
  "user.selectcustomer": "เลือกลูกค้า",
  "user.selectlanguage": "เลือกภาษา",
  "user.view": "ดูผู้ใช้",
  "userEdit.cancel.confirm": "คุณแน่ใจไหมว่าต้องการยกเลิก",
  "userEdit.cancel.create.external": "ยกเลิก 'สร้างผู้ใช้ภายนอก'",
  "userEdit.cancel.create.internal": "ยกเลิก 'สร้างผู้ใช้ภายใน'",
  "userEdit.cancel.edit.external": "ยกเลิก 'แก้ไขผู้ใช้ภายนอก'",
  "userEdit.cancel.edit.internal": "ยกเลิก 'แก้ไขผู้ใช้ภายใน'",
  "userEdit.message.cannotedit": "คุณไม่สามารถแก้ไขรายละเอียดของผู้ใช้รายนี้ โปรดติดบริษัท เบรนน์แท็กฯ หากคุณต้องแก้ไขรายละเอียดผู้ใช้รายนี้",
  "userrole.Admin": "ผู้ดูแลระบบ",
  "userrole.CSR": "ลูกค้าสัมพันธ์",
  "userrole.ReadUser": "ผู้ใช้แบบอ่านอย่างเดียว",
  "userrole.SuperAdmin": "ผู้ดูแลระบบขั้นสูง",
  "userrole.User": "ผู้ใช้งาน",
  "userrole.UserAdmin": "ผู้ดูแลระบบผู้ใช้",
  "userrole.UserManager": "ผู้ใช้งานหลัก",
  "userrole.description": "บทบาทของผู้ใช้",
  "validationerror.invalid-date": "วันที่ที่เลือกไม่ถูกต้อง",
  "validationerror.invalid-moq": "จำนวนที่เลือกต่ำกว่าปริมาณการสั่งซื้อขั้นต่ำ",
  "validationerror.not-authorized": "ไม่มีอำนาจ",
  "validationerror.not-found": "ไม่มีผลิตภัณฑ์นี้",
  "validationerror.price-changed": "ราคาของผลิตภัณฑ์นี้ได้รับการอัปเดตแล้ว",
  "validationerror.price-mismatch": "ราคาบางส่วนได้รับการอัปเดตแล้ว",
  "validationerror.price-not-found": "ไม่พบราคาสำหรับผลิตภัณฑ์นี้ กรุณาติดต่อเราทางแชทเพื่อขอราคา",
  "validationerror.uom-mismatch": "หน่วยของผลิตภัณฑ์นี้ไม่ตรงกัน",
  "video.invoices": "ใบแจ้งหนี้",
  "video.invoices.description": "เรียนรู้เกี่ยวกับวิธีค้นหา และดาวน์โหลดใบแจ้งหนี้ใน Brenntag Connect",
  "video.ordering": "การสั่งซื้อ และการสั่งซื้อซ้ำ",
  "video.ordering.description": "เรียนรู้เกี่ยวกับวิธีสั่งซื้อ และสั่งซื้อซ้ำ ใน Brenntag Connect",
  "video.orderlist": "ดูรายการสั่งซื้อ",
  "video.orderlist.description": "เรียนรู้เกี่ยวกับวิธีดูประวัติการสั่งซื้อของคุณใน Brenntag Connect",
  "video.productsearch": "ค้นหาผลิตภัณฑ์",
  "video.productsearch.description": "เรียนรู้เกี่ยวกับวิธีค้นหาผลิตภัณฑ์ใน Brenntag Connect"
} as const
